/**
 * Per-life-space "last visited project" memory (localStorage, per window).
 *
 * Written whenever a project tab becomes active (any window mode); read by the
 * compact ProjectSwitcher's life-space menu so switching the space lands on
 * the project the user last worked in (fallback: the space's first project).
 * Deliberately NOT synced — a per-device UI convenience, like the window mode.
 */

const key = (lifeSpace: string) => `last-project-${lifeSpace}`

export function rememberLastProject(lifeSpace: string, projectId: string): void {
  try {
    localStorage.setItem(key(lifeSpace), projectId)
  } catch { /* ignore (storage full / privacy mode) */ }
}

export function getLastProjectId(lifeSpace: string): string | null {
  try {
    return localStorage.getItem(key(lifeSpace))
  } catch {
    return null
  }
}
